import React, { useEffect, useMemo } from "react";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { useSetSelectFilterOption } from "~/hooks/SelectValue";
import {
  EN_NAME_OPTIONS,
  LANG,
  LOCALIZE_NAME_OPTIONS,
} from "~/constans/commom";

import CustomSelect from "~/shared/ui/Fields/Select/CustomSelect";

import s from "./Filter.less";

interface IProps {
  options: string[];
  type?: string;
  isYear?: boolean;
  width?: number;
  isNoneFilterBy?: boolean;
}

const Filter: React.FC<IProps> = ({
  isYear = false,
  options = [],
  type = "",
  width,
  isNoneFilterBy = true,
}) => {
  let isEn = localStorage.getItem("language") === LANG.en;
  const selectFilterOption = useSetSelectFilterOption();
  const setData = useSetLocationData();
  const { searchField } = useGetLocationData();
  let defaultFilterOption = useMemo(
    () =>
      selectFilterOption(
        searchField || (isNoneFilterBy ? "ui.filter_by" : "Contract"),
        type
      ),
    [searchField]
  );

  const arrIsAnnouncements = ["isAnnouncementsAccess", "isAnnouncementsSend"];

  useEffect(() => {
    [...LOCALIZE_NAME_OPTIONS, ...EN_NAME_OPTIONS].includes(searchField) &&
      setData("searchField", "");
  }, [isEn]);

  const setSearchField = (e) => {
    const localizeOption =
      LOCALIZE_NAME_OPTIONS.includes(e.value) && isEn
        ? `${e.value}En`
        : e.value;
    setData(
      "searchField",
      localizeOption,
      "event",
      arrIsAnnouncements.includes(e.value) ? "true" : "",
      "page",
      0,
      "pageModal",
      0
    );
  };

  const preparedOptions = (
    type && isNoneFilterBy ? ["ui.filter_by", ...options] : options
  ).map((option) => selectFilterOption(option, type));

  return (
    <div style={{ width }} className={s.filter_select}>
      <CustomSelect
        onChange={setSearchField}
        options={preparedOptions}
        // value={(!type || isYear) ?  preparedOptions[0] : defaultFilterOption}
        value={
          !type
            ? isYear && searchField
              ? defaultFilterOption
              : preparedOptions[0]
            : defaultFilterOption
        }
        // defaultValue={(!type || isYear) ? preparedOptions[0] : defaultFilterOption}
        defaultValue={
          !type
            ? isYear && searchField
              ? defaultFilterOption
              : preparedOptions[0]
            : defaultFilterOption
        }
      />
    </div>
  );
};

export default Filter;
